type TTableSetting = {
  ROWS_PER_PAGE: number;
  ROWS_PER_PAGE_LIST: number[];
  NO_DATA_LABEL: string;
  NO_RESULTS_LABEL: string;
  ROWS_PER_PAGE_LABEL: string;
};

export const ROWS_PER_PAGE = 25;
export const ROWS_PER_PAGE_SM = 5;

export const ROWS_PER_PAGE_LIST: Array<number> = [25, 50, 100];
export const ROWS_PER_PAGE_LIST_SM: Array<number> = [5, 10, 25];

export const NO_DATA_LABEL = 'Нет данных';

export const NO_RESULTS_LABEL = 'Совпадений не найдено';

export const ROWS_PER_PAGE_LABEL = 'Записей на странице:';

export const TABLE_SETTINGS: TTableSetting = {
  ROWS_PER_PAGE,
  ROWS_PER_PAGE_LIST,
  NO_DATA_LABEL,
  NO_RESULTS_LABEL,
  ROWS_PER_PAGE_LABEL,
};

export const TABLE_DEFAULT_COLUMN = {
  COLUMN_ID: 'ИД',
};
